import "./available-vehicles-slider.scss";

import React from "react";
import { Link } from "gatsby";
import Slider from "react-slick";

const AvailableVehiclesSlider = ({ vehicles, trailers }) => {
  const availableSlider = {
    dots: true,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    draggable: true,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <div className="available-slider">
      <h2 className="available-slider__title">Pojazdy dostępne od ręki</h2>
      <div className="available-slider__subtitle">
        SZYBKI PRZEGLĄD AKTUALNYCH OFERT POJAZDÓW NOWYCH I UŻYWANYCH
      </div>
      <Link
        to="/pojazdy-dostepne-od-reki/?used=true"
        className="btn btn--red-rounded available-slider__see-more-btn"
      >
        Zobacz wszystkie
      </Link>
      {vehicles.length + trailers.length >= 3 ? (
        <Slider {...availableSlider}>
          {vehicles?.map((node, index) => {
            const vehicle = node.node;
            return (
              <div key={index}>
                <Link to={vehicle.uri}>
                  <div className="available-slider__single-slide">
                    <div
                      className="available-slider__slide-thumbnail"
                      style={{
                        backgroundImage: `url(
                    ${vehicle.vehicles.gallery[0]?.sourceUrl}
                  )`,
                      }}
                    />
                    <div className="available-slider__bottom-container">
                      <div className="available-slider__logo-container">
                        <img
                          src={
                            vehicle.vehiclesBrand?.nodes[0]
                              ?.vehiclesBrandCategory?.logoSmall?.sourceUrl
                          }
                          alt=""
                          className="available-slider__slide-logo img-fluid"
                        />
                      </div>
                      <div className="available-slider__slide-name">
                        {vehicle.vehicles.name}
                      </div>
                      <div className="btn btn--text btn--bold">
                        Przejdź do oferty
                      </div>
                    </div>
                  </div>
                </Link>
              </div>
            );
          })}
          {trailers?.map((node, index) => {
            const trailer = node.node;
            return (
              <Link to={trailer.uri}>
                <div key={index}>
                  <div className="available-slider__single-slide">
                    <div
                      className="available-slider__slide-thumbnail"
                      style={{
                        backgroundImage: `url(
                    ${trailer.vehicles.gallery[0]?.sourceUrl}
                  )`,
                      }}
                    />
                    <div className="available-slider__bottom-container">
                      <div className="available-slider__logo-container">
                        <img
                          src={
                            trailer.trailersBrand?.nodes[0]
                              ?.trailersBrandCategory?.logoSmall?.sourceUrl
                          }
                          alt=""
                          className="available-slider__slide-logo img-fluid"
                        />
                      </div>
                      <div className="available-slider__slide-name">
                        {trailer.vehicles.name}
                      </div>
                      <div className="btn btn--text btn--bold">
                        Przejdź do oferty
                      </div>
                    </div>
                  </div>
                </div>
              </Link>
            );
          })}
        </Slider>
      ) : (
        <div className="row justify-content-center">
          {vehicles?.map((node, index) => {
            const vehicle = node.node;
            return (
              <div className="col-md-4" key={index}>
                <Link to={vehicle.uri}>
                  <div className="available-slider__single-slide">
                    <div
                      className="available-slider__slide-thumbnail"
                      style={{
                        backgroundImage: `url(
                    ${vehicle.vehicles.gallery[0]?.sourceUrl}
                  )`,
                      }}
                    />
                    <div className="available-slider__bottom-container">
                      <div className="available-slider__logo-container">
                        <img
                          src={
                            vehicle.vehiclesBrand?.nodes[0]
                              ?.vehiclesBrandCategory?.logoSmall?.sourceUrl
                          }
                          alt=""
                          className="available-slider__slide-logo img-fluid"
                        />
                      </div>
                      <div className="available-slider__slide-name">
                        {vehicle.vehicles.name}
                      </div>
                      <div className="btn btn--text btn--bold">
                        Przejdź do oferty
                      </div>
                    </div>
                  </div>
                </Link>
              </div>
            );
          })}
          {trailers?.map((node, index) => {
            const trailer = node.node;
            return (
              <div className="col-md-4" key={index}>
                <Link to={trailer.uri}>
                  <div className="available-slider__single-slide">
                    <div
                      className="available-slider__slide-thumbnail"
                      style={{
                        backgroundImage: `url(
                    ${trailer.vehicles.gallery[0]?.sourceUrl}
                  )`,
                      }}
                    />
                    <div className="available-slider__bottom-container">
                      <div className="available-slider__logo-container">
                        <img
                          src={
                            trailer.trailersBrand?.nodes[0]
                              ?.trailersBrandCategory?.logoSmall?.sourceUrl
                          }
                          alt=""
                          className="available-slider__slide-logo img-fluid"
                        />
                      </div>
                      <div className="available-slider__slide-name">
                        {trailer.vehicles.name}
                      </div>
                      <div className="btn btn--text btn--bold">
                        Przejdź do oferty
                      </div>
                    </div>
                  </div>
                </Link>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default AvailableVehiclesSlider;
